export default __webpack_public_path__ + "static/media/sticker-x.f953ef5d.png";